import styles from './Copyright.module.css';

const Copyright = () => {
  const year = new Date().getFullYear();

  return (
    <div className={styles.copyright}>
      <p>&copy; {year} GYMNAZE. All rights reserved.</p>
    </div>
  );
};

export default Copyright;